<template>
	<popup-dialog v-model="openModal">
		<span slot="header">עדכון פרטים</span>
		<v-row>
			<v-col>
				<v-form @submit.prevent="submit">
					<surveyor-select :multiple="false" v-model="form.surveyor_id"/>
					<v-text-field v-model="form.start_date"
                        @focusout="changeStartDate()"
                        :min="isAdmin ? '' : minDate" type="datetime-local" :label='$t("pages.orderFilter.matchedTo")'/>
					<smart-input v-model="form.internal_note" :label='$t("dialog.match.internalNote")'></smart-input>
					<smart-input v-model="form.client_note" :label='$t("dialog.match.clientNote")'></smart-input>
					<status-select :plus="false" v-model="form.status"/>
					<v-alert v-if="alertHasDifference" type="warning">שים לב! ישנם מדידות עם נתונים שונים, לחיצה על עדכון תשווה את הנתונים הנ"ל בכל המדידות</v-alert>
					<v-btn :loading="inProgress" type="submit" color="primary">עדכון</v-btn>
				</v-form>
			</v-col>
		</v-row>
	</popup-dialog>
</template>

<script>
	import SurveyorSelect from "dev/view/users/SurveyorSelect";
	import StatusSelect from "dev/view/measurements/StatusSelect";
	import {types} from "dev/store/modules/Measurement.module";
  import moment from "moment";

	export default {
		name: "update-form",
		components: {StatusSelect, SurveyorSelect},
		props: {
			value: {},
			selected: {type: Array, default: () => []}
		},
		data() {
			return {
				inProgress: false,
				alertHasDifference: false,
				form: {
					surveyor_id: null,
					status: null,
					start_date: null,
					internal_note: null,
          additional_price: null,
					client_note: null
				}
			};
		},
		methods: {
      changeStartDate() {
        this.$nextTick(() => {
          let date = this.form.start_date;
          if (moment(date).isBefore()) {
            swal.fire({
              title: this.$t("dialog.error.wrongDate"),
              text: this.$t("dialog.error.wrongDateText"),
            });
            this.form.start_date = null;
          }
        });
      },
			async submit() {
				this.inProgress = true;
				await this.$store.dispatch(types.MULTI_UPDATE, {...this.form, measurement: this.selectedIds});
				this.inProgress = false;
				this.openModal = false;
				this.$emit("updated");
			}
		},
		computed: {
			selectedIds() {
				return this.selected.map(s => s.id);
			},
			openModal: {
				get() {
					return this.value;
				}, set(val) {
					this.$emit("input", val);
				}
			},
			isAdmin(){
				return this.$store.getters.isAdmin;
			},
			minDate(){
				return moment().subtract(-1,"m").format("YYYY-MM-DDThh:mm");
			},
		},
		watch: {
			selected: {
				immediate: true,
				handler() {

					this.alertHasDifference = null;
					["surveyor_id", "status", "start_date", "client_note", "internal_note"].forEach((key) => {
						this.form[key] = null;
						let values = this.selected.map(select => select[key]);
						if ((new Set(values)).size === 1) {
							if (key === "start_date") {
								this.form.start_date = values[0] ? values[0].replace(" ", "T") : null;
							} else
								this.form[key] = values[0];
						} else {
							this.alertHasDifference = true;
						}
					});

				}
			}
		}
	};
</script>

<style scoped>

</style>
